import routineReducerFactory from "./routineReducerFactory";
import {fetchFairSuppliers} from "../actions/routines";

const fairSuppliers = routineReducerFactory(fetchFairSuppliers, {data: []});

export default fairSuppliers;